import axiosInstance from '@/config/axios'
import { logError, logInfo, logDebug } from '@/utils/logger'

export interface UserPreference {
  id?: number
  preference_key: string
  preference_value: any
  created_at?: string
  updated_at?: string
}

export const userPreferencesService = {
  async getPreference(key: string): Promise<UserPreference | null> {
    try {
      logDebug(`Récupération de la préférence: ${key}`)
      // Récupérer toutes les préférences de l'utilisateur
      const response = await axiosInstance.get('/user-preferences/')
      
      if (!response.data || response.data.length === 0) {
        logDebug(`Aucune préférence trouvée pour la clé: ${key}`)
        return null
      }
      
      // Filtrer manuellement pour trouver la préférence avec la clé demandée
      const preference = response.data.find((pref: UserPreference) => pref.preference_key === key)
      
      if (!preference || !preference?.preference_value) {
        logDebug(`Préférence non trouvée pour la clé: ${key}`)
        return null
      }
      
      logInfo(`Préférence récupérée avec succès: ${key}`, preference.preference_value)
      return preference
    } catch (error) {
      logError(`Erreur lors de la récupération de la préférence: ${key}`, error)
      return null
    }
  },

  async upsertPreference(key: string, value: any): Promise<UserPreference | null> {
    try {
      // S'assurer que la valeur n'est pas null ou undefined
      if (value === null || value === undefined) {
        logError(`Tentative d'enregistrement d'une valeur null ou undefined pour la clé: ${key}`)
        return null
      }
      
      logDebug(`Tentative d'enregistrement de la préférence: ${key}`, value)
      
      // Vérifier si le token d'authentification est présent dans les headers
      const headers = axiosInstance.defaults.headers.common['Authorization']
      logDebug('Token d\'authentification dans les headers:', headers ? 'Présent' : 'Absent')
      
      const response = await axiosInstance.post('/user-preferences/upsert/', {
        preference_key: key,
        preference_value: value
      })
      
      logInfo(`Préférence enregistrée avec succès: ${key}`, response.data)
      return response.data
    } catch (error: any) {
      logError(`Erreur lors de l'enregistrement de la préférence: ${key}`, error)
      
      // Afficher plus de détails sur l'erreur
      if (error.response) {
        logError('Détails de l\'erreur:', {
          status: error.response.status,
          statusText: error.response.statusText,
          data: error.response.data
        })
      }
      
      return null
    }
  }
}

